<template>
  <div id="site_content">
    <transition appear v-on:appear="removeLoader"> 
      <div class="loader p-fixed">
        <div class="loader__inner">
          <svg class="spinner" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
            <g id="Layer_8">
              <g>
                <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="3.5385" y1="100" x2="193.5385" y2="100">
                  <stop  offset="5.618001e-03" style="stop-color:#41354D"/>
                  <stop  offset="0.6101" style="stop-color:#41354D"/>
                  <stop  offset="0.8039" style="stop-color:#41354D"/>
                  <stop  offset="0.8379" style="stop-color:#68295B"/>
                  <stop  offset="0.8931" style="stop-color:#A1186F"/>
                  <stop  offset="0.9405" style="stop-color:#CA0B7E"/>
                  <stop  offset="0.9777" style="stop-color:#E40388"/>
                  <stop  offset="1" style="stop-color:#ED008B"/>
                </linearGradient>
                <path style="fill:url(#SVGID_7_);" d="M98.5,34c36.4,0,66,29.6,66,66s-29.6,66-66,66s-66-29.6-66-66S62.1,34,98.5,34 M98.5,5
                  c-52.5,0-95,42.5-95,95s42.5,95,95,95c52.5,0,95-42.5,95-95S151,5,98.5,5L98.5,5z"/>
              </g>
            </g>
            <g id="Layer_9">
              <g>
                <circle style="fill:#ED008B;" cx="180.1" cy="100.2" r="17.9"/>
              </g>
            </g>
            <g>
              <path style="fill:#41354D;" d="M67.7,104.6v3.1H58V92.2h3.3v12.4H67.7z"/>
              <path style="fill:#41354D;" d="M78.3,93c0.9,0.6,1.7,1.6,2.2,2.8c0.5,1.2,0.8,2.6,0.8,4.3c0,1.7-0.3,3.1-0.8,4.3
                c-0.5,1.2-1.2,2.1-2.2,2.8c-0.9,0.6-2,1-3.3,1c-1.3,0-2.4-0.3-3.3-1c-0.9-0.6-1.7-1.6-2.2-2.8c-0.5-1.2-0.8-2.6-0.8-4.3
                c0-1.7,0.3-3.1,0.8-4.3c0.5-1.2,1.2-2.1,2.2-2.8c0.9-0.6,2.1-1,3.3-1C76.3,92,77.4,92.3,78.3,93z M72.8,96.4
                c-0.5,0.8-0.7,2-0.7,3.6c0,1.6,0.2,2.8,0.7,3.6c0.5,0.8,1.2,1.2,2.1,1.2s1.6-0.4,2.1-1.2c0.5-0.8,0.7-2,0.7-3.6
                c0-1.6-0.2-2.8-0.7-3.6c-0.5-0.8-1.2-1.2-2.1-1.2S73.3,95.6,72.8,96.4z"/>
              <path style="fill:#41354D;" d="M90.4,104.3h-4.4l-0.9,3.5h-3.3l4.5-15.5h4l4.5,15.5h-3.4L90.4,104.3z M89.7,101.5l-0.9-3.7
                l-0.6-2.4h0l-0.5,2.4l-1,3.7H89.7z"/>
              <path style="fill:#41354D;" d="M106.2,94.2c1.1,1.3,1.6,3.3,1.6,5.8s-0.5,4.4-1.6,5.8c-1.1,1.3-2.6,2-4.6,2h-5.4V92.2h5.4
                C103.6,92.2,105.1,92.9,106.2,94.2z M103.6,103.5c0.5-0.8,0.8-2,0.8-3.5c0-1.6-0.3-2.7-0.8-3.5c-0.5-0.8-1.3-1.2-2.4-1.2h-1.8v9.4
                h1.8C102.3,104.7,103.1,104.3,103.6,103.5z"/>
              <path style="fill:#41354D;" d="M113.4,107.8H110V92.2h3.3V107.8z"/>
              <path style="fill:#41354D;" d="M127.7,107.8H124l-4-8.4l-1-2.4h0l0.1,2.9v7.8h-2.9V92.2h3.7l4,8.4l1,2.4h0l-0.1-2.9v-7.8h2.9
                V107.8z"/>
              <path style="fill:#41354D;" d="M142,99.4v8.4h-2.3l-0.1-1.8c-0.7,1.4-2,2.1-3.7,2.1c-1.2,0-2.2-0.3-3.1-0.9
                c-0.9-0.6-1.6-1.5-2.1-2.7c-0.5-1.2-0.8-2.6-0.8-4.3c0-1.7,0.3-3.1,0.8-4.3c0.5-1.2,1.3-2.1,2.2-2.8c1-0.6,2.1-1,3.4-1
                c1.5,0,2.6,0.3,3.5,0.9c0.9,0.6,1.6,1.6,2.1,3l-3.1,1.5c-0.2-0.8-0.4-1.3-0.9-1.7c-0.4-0.4-1-0.6-1.6-0.6c-1,0-1.7,0.4-2.3,1.2
                c-0.5,0.8-0.8,2-0.8,3.6c0,3.3,1,4.9,3.1,4.9c0.8,0,1.4-0.2,1.9-0.7c0.5-0.4,0.7-1.1,0.7-1.9v-0.2H136v-2.7H142z"/>
            </g>
          </svg>
        </div>
      </div>
    </transition>
    <div class="site_content">
      <Header class="header"/>
      <router-view/>
    </div>
  </div>
</template>
<script>
  import Header from './components/Header.vue';
  export default {
    name: 'App',
    components: {
      Header
    },
    data(){
      return{
        spinnerAnim: null
      }
    },
    mounted(){
      let menuBtnCloseSvg = document.getElementById('Layer_8')
      let menuBtnCloseSvg2 = document.getElementById('Layer_9')
      this.spinnerAnim = new TimelineMax({repeat: -1})
      this.spinnerAnim.timeScale(1.6)
      this.spinnerAnim.to(menuBtnCloseSvg, 2, {rotation:360, transformOrigin:"50% 50%", ease: Power0.easeNone} )
      .to(menuBtnCloseSvg2, 1, {scale: 0, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=2')
      .to(menuBtnCloseSvg2, 1, {scale: 1, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=1')
    },
    methods:{
      removeLoader(el){
        let self = this
        new TimelineMax({onComplete: ()=>{
            self.spinnerAnim.pause()
          } 
        })
        .to(el, 1.2, {css: { opacity: 0, pointerEvents: 'none'}, ease: Power3.easeIn})
        .to('.site_content', 0.6, {css: { y:0, opacity: 1}, ease: Power1.easeOut},'-=0.6')
        .to('.spinner', 0.6, {css: {y: -200, opacity: 0}, ease: Power1.easeOut},'-=0.6')
      }
    }
  }
</script>
<style lang="scss">
  .loader{
    background: url(./assets/images/soft-pad.png);
    background-color: #00BED0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    &__inner{
      max-width: 120px;
      svg{
        width: 100%;
        height: 100%;
      }
    }
  }
  #site_content{
    overflow: hidden;
  }
  .site_content{
    background: url(assets/images/vue-bg.svg) no-repeat;
    background-position: right top;
    transform: translateY(-200px);
    opacity: 0;
  }
</style>


